import styled from 'styled-components';

const BackLinkText = styled.h3`
  color: #6d7184;
  cursor: inherit;
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
`;

const BackLinkArrow = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

const BackHyperLink = styled.a`
  margin: 0;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  padding-bottom: 34px;

  & :hover {
    text-decoration: none;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    padding-bottom: 18px;
  }
`;

export { BackHyperLink, BackLinkText, BackLinkArrow };
